import React from 'react'
import { useTranslation } from "react-i18next";
import Footer from './Footer';
import { Container, Row, Col } from 'react-bootstrap';
import { HashLink } from 'react-router-hash-link';
import Gallery from './Gallery';








const Home = () => {

  const { t } = useTranslation();

  const cardStyle = {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "10px",
    width: "280px",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    textAlign: "center"
  };
  
  const iconStyle = {
    width: "50px",
    height: "50px",
    marginBottom: "15px"
  };
  
  const logoStyle = {
    width: "150px",
    objectFit: "contain",
    transition: "filter 0.3s ease",
  };
  



  return (
    <div>
      
      
      <section className="bannar">
        <Container>
          <Row >  
            <Col md={7} sm={12} className="bannartext animate__animated animate__fadeInLeft animate__delay-0.1s animate-duration: 2s" >
                  <h2> {t("title")} </h2>

                  <h5> {t("description")}</h5>
                 
    
              <HashLink to="/contact"><button> {t("contact")}    </button></HashLink>
            </Col>
            <Col md={5} sm={12} className="bannarimgs animate__animated animate__fadeInRight animate__delay-0.1s animate-duration: 2s " >
             
           
              
            </Col>
          </Row>
        </Container>
      </section>

      <section className="why-us" style={{ padding: "60px 20px", backgroundColor: "#f9f9f9" }}>
  <div style={{ maxWidth: "1200px", margin: "0 auto", textAlign: "center" }}>
    <h2 style={{ fontSize: "2rem", marginBottom: "20px" }}>{t("whyUsTitle")}</h2>
    <p style={{ fontSize: "1.1rem", marginBottom: "40px" }}>{t("whyUsDescription")}</p>
    <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "20px" }}>
      <div style={cardStyle}>
        <img src="positive.png" alt="" style={iconStyle} />
        <h4>{t("experience")}</h4>
        <p>{t("experienceDesc")}</p>
      </div>
      <div style={cardStyle}>
        <img src="24-hours-support.png" alt="" style={iconStyle} />
        <h4>{t("supporta")}</h4>
        <p>{t("supportDesc")}</p>
      </div>
      <div style={cardStyle}>
        <img src="badge.png" alt="" style={iconStyle} />
        <h4>{t("quality")}</h4>
        <p>{t("qualityDesc")}</p>
      </div>
    </div>
  </div>
</section>


<section className="partners" style={{ padding: "60px 20px", backgroundColor: "#fff" }}>
  <div style={{ maxWidth: "1200px", margin: "0 auto", textAlign: "center" }}>
    <h2 style={{ fontSize: "2rem", marginBottom: "40px" }}>{t("ourPartners")}</h2>
    <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "30px" }}>
     <a href="https://igs-eg.com/">
     <img src="igs.png" alt="Partner 1" style={logoStyle} />
      </a> 
     <a href="https://igs-eg.com/">
      <img src="WhatsApp Image 2024-02-06 at 12.14.11_ab3efaed.png" alt="Partner 2" style={logoStyle} />
      </a> 
    <a href="https://massa-co.com">
    <img src="1749424223002-removebg-preview.png" alt="Partner 3" style={logoStyle} />
      </a>  
      
    </div>
  </div>
</section>


    <Gallery/>
       
      </div>

  )
}

export default Home